import { render, staticRenderFns } from "./metalPurifyRpt.vue?vue&type=template&id=31af123b&scoped=true&"
import script from "./metalPurifyRpt.vue?vue&type=script&lang=js&"
export * from "./metalPurifyRpt.vue?vue&type=script&lang=js&"
import style0 from "./metalPurifyRpt.vue?vue&type=style&index=0&id=31af123b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31af123b",
  null
  
)

export default component.exports